import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Start from "@/views/Start.vue";
import Contacts from "@/views/Contacts.vue";
import Agreement from "@/views/Agreement.vue";
import Finance from "@/views/Finance.vue";
import Reports from "@/views/Reports.vue";
import Issues from "@/views/Issues.vue";
import Projects from "@/views/Projects.vue";
import AdminPanel from "@/views/admins/AdminPanel.vue";
import IntegrationNumber from "@/views/admins/IntegrationNumber.vue";
import Documentation from "@/views/Documentation.vue";
import Integrations from "@/views/Integrations.vue";
import Integration from "@/components/Integration.vue";
import PageNotFound from "@/views/PageNotFound.vue";
import Users from "@/views/admins/Users.vue";
import UpdateUsers from "@/views/admins/UpdateUsers.vue";
import CreateUsers from "@/views/admins/CreateUsers.vue";
import ClockifyReport from "@/views/admins/ClockifyReport.vue";
import AdminAgreement from "@/views/admins/AdminAgreement.vue";
import UploadAgreement from "@/views/admins/UploadAgreement.vue";
import ProjectConfig from "@/views/admins/ProjectConfig.vue";
import AdminTeams from "@/views/admins/AdminTeams.vue";
import CreateTeams from "@/views/admins/CreateTeams.vue";
import UpdateTeams from "@/views/admins/UpdateTeams.vue";
import SharedFiles from "@/views/SharedFiles.vue";
import CreateFolder from "@/views/CreateFolder.vue";
import Folders from "@/views/Folders.vue";
import UploadFile from "@/views/UploadFile.vue";
import IntegrationSummary from "@/views/admins/IntegrationSummary.vue";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "Start",
    component: Start
  },
  {
    path: "/contacts",
    name: "Contacts",
    component: Contacts
  },
  {
    path: "/agreement",
    name: "Agreement",
    component: Agreement
  },
  {
    path: "/finance",
    name: "Finance",
    component: Finance
  },
  {
    path: "/reports",
    name: "Reports",
    component: Reports
  },
  {
    path: "/projects",
    name: "Projects",
    component: Projects
  },
  {
    path: "/documentation/:id",
    name: "documentation",
    component: Documentation,
    props: true
  },
  {
    path: "/documentation",
    name: "documentations",
    component: Documentation
  },

  {
    path: "/integrations",
    name: "integrations",
    component: Integrations
  },
  {
    path: "/integrations/:id",
    name: "integration",
    component: Integration,
    props: true
  },
  {
    path: "/issues",
    name: "Issues",
    component: Issues
  },
  {
    path: "/admin-panel",
    name: "AdminPanel",
    component: AdminPanel
  },
  {
    path: "/admin-integration-number",
    name: "IntegrationNumber",
    component: IntegrationNumber
  },
  {
    path: "/admin-users",
    name: "Users",
    component: Users,
    props: true
  },
  {
    path: "/admin-update-users/:username",
    name: "UpdateUsers",
    component: UpdateUsers,
    props: true
  },
  {
    path: "/admin-create-users",
    name: "CreateUsers",
    component: CreateUsers,
    props: true
  },
  {
    path: "/admin-clockify-report",
    name: "ClockifyReport",
    component: ClockifyReport
  },
  {
    path: "/admin-agreement",
    name: "AdminAgreement",
    component: AdminAgreement
  },
  {
    path: "/admin-upload-agreement",
    name: "UploadAgreement",
    component: UploadAgreement
  },
  {
    path: "/admin-project-config",
    name: "ProjectConfig",
    component: ProjectConfig
  },
  {
    path: "/admin-teams",
    name: "AdminTeams",
    component: AdminTeams,
    props: true
  },
  {
    path: "/admin-create-teams",
    name: "CreateTeams",
    component: CreateTeams
  },

  {
    path: "/admin-update-teams/:update_id/:update_name",
    name: "UpdateTeams",
    component: UpdateTeams,
    props: true
  },
  {
    path: "/sharedfiles",
    name: "SharedFiles",
    component: SharedFiles,
    props: true
  },
  {
    path: "/folders/:name",
    name: "Folders",
    component: Folders,
    props: true
  },
  {
    path: "/create-folder",
    name: "CreateFolder",
    component: CreateFolder,
    props: true
  },
  {
    path: "/upload-file/:folder_name?",
    name: "UploadFile",
    component: UploadFile,
    props: true
  },
  {
    path: "/admin-integration-summary",
    name: "IntegrationSummary",
    component: IntegrationSummary
  },
  {
    path: "/*",
    name: "not-found",
    component: PageNotFound
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
